/** Promise-time helpers. ss-ptime is an INTEGER = seconds since midnight (24h). */

export function ptimeToHHMM(sec: number): string {
  if (!Number.isFinite(sec) || sec <= 0) return '';
  const h = Math.floor(sec / 3600);
  const m = Math.floor((sec % 3600) / 60);
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
}

export function hhmmToPtime(hhmm: string): number {
  const m = /^(\d{1,2}):(\d{2})$/.exec(hhmm.trim());
  if (!m) return 0;
  const h = Number(m[1]);
  const mm = Number(m[2]);
  if (h < 0 || h > 23 || mm < 0 || mm > 59) return 0;
  return h * 3600 + mm * 60;
}

const OPEN_H = 8;
const CLOSE_H = 18;

/** 30-min slot labels 08:00 .. 17:30. */
export const HALF_HOUR_SLOTS: string[] = (() => {
  const out: string[] = [];
  for (let h = OPEN_H; h < CLOSE_H; h++) {
    out.push(`${String(h).padStart(2, '0')}:00`);
    out.push(`${String(h).padStart(2, '0')}:30`);
  }
  return out;
})();

/** Bucket a ptime to a grid slot label. 0/blank -> '' (sin hora); out-of-hours clamps to an edge slot. */
export function ptimeToSlot(sec: number): string {
  if (!Number.isFinite(sec) || sec <= 0) return '';
  const clamped = Math.min(Math.max(sec, OPEN_H * 3600), CLOSE_H * 3600 - 1);
  const h = Math.floor(clamped / 3600);
  const half = (clamped % 3600) / 60 < 30 ? '00' : '30';
  return `${String(h).padStart(2, '0')}:${half}`;
}

/** Monday (local) of the week containing d. */
export function weekStartMonday(d: Date): Date {
  const x = new Date(d.getFullYear(), d.getMonth(), d.getDate());
  const dow = (x.getDay() + 6) % 7; // Mon=0 .. Sun=6
  x.setDate(x.getDate() - dow);
  return x;
}

/** Mon..Sat (6 days) from a Monday. */
export function weekDays(monday: Date): Date[] {
  return Array.from({ length: 6 }, (_, i) => {
    const d = new Date(monday);
    d.setDate(monday.getDate() + i);
    return d;
  });
}
